// Splash/intro screen: shown once per session before Home is fully interactive.
import React, { useEffect, useState } from "react";
import { audio } from "@/game/audio";

export default function SplashScreen({ onDone }) {
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => startLeaving(), 2400);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function startLeaving() {
    if (leaving) return;
    setLeaving(true);
    audio.unlock();
    audio.start();
    setTimeout(() => onDone && onDone(), 450);
  }

  return (
    <div
      onClick={startLeaving}
      data-testid="splash-screen"
      className={`fixed inset-0 z-[60] h-dvh min-h-screen arcade-bg flex flex-col items-center justify-center px-4 overflow-hidden transition-opacity duration-500 ${
            leaving ? "opacity-0" : "opacity-100"
      }`}
    >
      {/* App icon, large + blurred, sitting behind everything for depth. */}
      <img
        src="/apple-touch-icon.png"
        alt=""
        aria-hidden="true"
        className="absolute inset-0 m-auto anim-glow-pulse pointer-events-none"
        style={{
          width: "min(92vw, 520px)",
          height: "min(92vw, 520px)",
          filter: "blur(36px) brightness(1.15) saturate(1.15)",
          opacity: 0.55,
        }}
      />
      {/* Sharp icon in the middle as the hero mark. */}
      <img
        src="/apple-touch-icon.png"
        alt="Crossbeau Chaos"
        className="relative z-10 anim-floaty rounded-[28%]"
        style={{
          width: "min(44vw, 180px)",
          height: "min(44vw, 180px)",
          boxShadow: "0 0 40px rgba(0,255,255,0.35), 0 0 80px rgba(255,0,127,0.25)",
        }}
      />
      <h1 className="relative z-10 mt-6 font-display font-black text-5xl sm:text-7xl text-center leading-none anim-glow-pulse">
        <span className="neon-pink">CROSSBEAU</span>
        <br />
        <span className="neon-cyan">CHAOS</span>
      </h1>
      <p className="relative z-10 mt-8 font-display tracking-widest uppercase text-white/70 text-sm animate-pulse">
        Tap to start
      </p>
    </div>
  );
}
